import type { HttpClient } from 'services/api-client/client';
import { returnData } from 'services/api-client/client';
import type { GetDriftCauseGroupsQueryParams, GetDriftCauseGroupsResponse } from 'types/drift.types';

export default (client: HttpClient) => ({
  getDriftCauseGroups: ({ projectIds, ...params }: GetDriftCauseGroupsQueryParams) =>
    client
      .get<GetDriftCauseGroupsResponse>('drift-causes', {
        params: { ...params, projectIds: projectIds?.length ? projectIds.join(',') : undefined }
      })
      .then(returnData)
});
